import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import RoutesContainer from "./components/routes/routesContainer";
import { themeMui } from "./components/styled/theme";

const App = () => (
  <ThemeProvider theme={themeMui}>
    <CssBaseline />
    <RoutesContainer />
  </ThemeProvider>
);

export default App;
